export default {
  setRequestVacations: (state, requestVacations) => {
    state.requestVacations = requestVacations;
  },

  setSubscription: (state, subscription) => {
    state.subscription = subscription;
  },

  setRequestVacationsFilters: (state, requestVacationsFilters) => {
    state.requestVacationsFilters = requestVacationsFilters;
  },

  setRequestVacationsPaginationOptions: (
    state,
    requestVacationsPaginationOptions
  ) => {
    state.requestVacationsPaginationOptions = requestVacationsPaginationOptions;
  },

  setRequestVacationsBadgeQTY: (state, requestVacationsBadgeQTY) => {
    state.requestVacationsBadgeQTY = requestVacationsBadgeQTY;
  }
};
